/* global angular, moment */
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name helpers.sv.factory:Sv
   *
   * @description
   *
   */
  angular
    .module('vcutils.sv')
    .factory('Sv', Sv)
    .factory('Svahead', Svahead);
  
  
  Sv.$inject = ['restmod'];
  function Sv(restmod) {
    return restmod.model('/routes/svs').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/svs/svahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          } // $searchahead
        } // Model
      }// extend
    });
  }
  
  
  Svahead.$inject = ['restmod'];
  function Svahead(restmod) {
    return restmod.model('/routes/svs/svahead');
  }

// klammerfriedhof
}());
